<prism-nav-group *transloco="let t">
	<prism-nav-button
		*ngFor="let navItem of navItems()"
		selected="{{ navItem.selected }}"
		disabled="{{ navItem.disabled }}"
		id="sh-app-shell-prism-nav-button-{{ navItem.labelId }}"
		[routerLink]="[navItem.navigateUrl]"
		[href]="[navItem.navigateUrl]"
		(click)="handleNavButtonClick($event, navItem)"
	>
		<prism-icon
			id="sh-app-shell-prism-nav-icon-{{ navItem.labelId }}"
			slot="icon"
			icon="{{ navItem.icon }}"
		></prism-icon>
		<span id="sh-app-shell-prism-nav-span-{{ navItem.labelId }}">{{ t(navItem.label) }}</span>
	</prism-nav-button>

	@if (hasSecondaryNav()) {
		<prism-nav-toggle-button
			id="sh-app-shell-prism-nav-toggle-button"
			disabled="false"
			[isOpen]="showSecondaryNav()"
			(click)="toggleShowSecondaryNav()"
		>
		</prism-nav-toggle-button>
	}
</prism-nav-group>
